module.exports = __webpack_public_path__ + "static/media/banner.ca101244.png";